import StockCountsList from "@/components/inventory/stock-counts/StockCountsList";
import { useAppSelector } from "@/redux/features/hooks";

const StockCountsPage = () => {
  const restaurant = useAppSelector((state) => state.user.currentRestaurant);
  if (!restaurant) return null;
  return <StockCountsList restaurantId={restaurant.id} />;
};

export default StockCountsPage;
